import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { linkBasePc } from '@src/mobile/components/Link';
import styles from './index.css';

const Header = ({ content }) => {
    return (
        <div className={styles.wrap}>
            <div className={styles.content}>
                <div className={styles.title}>热门评论</div>
            </div>
            <a
                href={`${linkBasePc}/loc/timeline/event/${content.base62Id}`}
                className={styles.eventLink}
                target="_blank">
                <div className={styles.event}>
                    <div className={styles.eventText}>{content.title}</div>
                    <div className={styles.eventArrow} />
                </div>
            </a>
        </div>
    );
};

Header.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Header);
